<template>
  <v-container  grid-list-xs>  
    <v-row align="center" justify="center" class="mt-3">
      <v-col cols="12" xl="9" lg="9" class="text-justify">

        <v-row align="center" justify="center">
          <v-col cols="12" xl="8" lg="8" class="text-center">
              <h1> <p> Material de Muestra </p></h1>
          </v-col>
        </v-row>

        <p><a href="https://olimpiadacdmx.quimica.unam.mx/admin/material/00 Temario Olimpiada de Quimica.pdf" target="_blank">00 Temario Olimpiada de Quimica</a></p>
        <p><a href="https://olimpiadacdmx.quimica.unam.mx/admin/material/01 Examen muestra Fase 01.pdf" target="_blank">01 Examen muestra Fase 01</a></p>
        <p><a href="https://olimpiadacdmx.quimica.unam.mx/admin/material/02 Examen muestra Fase Eliminatoria Nivel A.pdf" target="_blank">02 Examen muestra Fase Eliminatoria Nivel A</a></p>
        <p><a href="https://olimpiadacdmx.quimica.unam.mx/admin/material/03 Examen muestra Fase Eliminatoria Nivel B.pdf" target="_blank">03 Examen muestra Fase Eliminatoria Nivel B</a></p>
      <!-- <pdf src="@/assets/convocatoria.pdf">Convocatoria</pdf> -->

      </v-col>
    </v-row>
  </v-container>  
</template>

<script>
import pdf from 'vue-pdf'

export default {
  metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Material de Apoyo - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },
  components: {
    pdf
  }
}
</script>

<style>

</style>